import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import { makeStyles, Icon } from '@material-ui/core'
import {
  CONTACT_TYPE_APP,
  CONTACT_TYPE_REGISTERED,
  CONTACT_TYPE_CRM,
  CONTACT_TYPE_OTHET,
} from 'app/main/notification/socialMediaSelect/socialMediaSelectConfig'
import { CHANNEL_SMS, CHANNEL_EMAIL, CHANNEL_CALL } from 'app/constants/channel'
import { useIntl } from 'react-intl'
import { useAppName } from 'commons/usePartner'
import LabelError from 'app/componentV4/Labels/LabelError'

const useStyles = makeStyles((theme) => ({
  endAdornment: {
    width: '100%',
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}))

const channelsLable = (channels, contact, prefix) => {
  switch (channels) {
    case CHANNEL_EMAIL:
      return `${prefix} Email: ${contact}`
    case CHANNEL_SMS:
      return `${prefix} SMS: ${contact}`
    case CHANNEL_CALL:
      return `${prefix} Automated Call: ${contact}`
    default:
      break
  }
}

const preferContactSelectDisplay = ({
  option,
  hideContact,
  formatMessage,
  appName,
}) => {
  switch (option.contactType) {
    case CONTACT_TYPE_APP:
      return `${appName} App`
    case CONTACT_TYPE_CRM:
      return channelsLable(option.channel, option.contact, 'CRM')
    case CONTACT_TYPE_OTHET:
      return channelsLable(option.channel, option.contact, 'Other')
    case CONTACT_TYPE_REGISTERED:
      return channelsLable(
        option.channel,
        hideContact
          ? `(${formatMessage({ id: 'notification.channel.restricted' })})`
          : option.contact,
        'Registered',
      )
    default:
      return ''
  }
}

const PreferredChannelSelector = ({
  id,
  value,
  onChange,
  placeholder,
  className,
  options,
  hideContact,
  error,
  helperText,
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()
  const appName = useAppName()
  const [optionsState, setOptionsState] = useState([])

  useEffect(() => {
    setOptionsState(options)
  }, [options])

  return (
    <div>
      <Autocomplete
        options={optionsState}
        getOptionLabel={(option) =>
          preferContactSelectDisplay({
            option,
            hideContact,
            formatMessage,
            appName,
          })
        }
        value={value}
        getOptionSelected={(option, value) => {
          return option.contact === value.contact
        }}
        className={className}
        noOptionsText={formatMessage({
          id: 'crm.form.receiveMethods.option.empty',
        })}
        onChange={(event, value) => {
          if (onChange) {
            onChange(value ? value : null)
          }
        }}
        renderOption={(option) => (
          <div className="flex justify-between w-full items-baseline ">
            <div>
              {preferContactSelectDisplay({
                option,
                hideContact,
                formatMessage,
                appName,
              })}
            </div>
            {!error && option.isBadContact && (
              <Icon className="text-15 text-orange-600 my-auto font-600">
                warning
              </Icon>
            )}
          </div>
        )}
        renderInput={(params) => (
          <div ref={params.InputProps.ref}>
            <SimpleInput
              id={id}
              placeholder={placeholder}
              error={error}
              endAdornment={
                <div className={classes.endAdornment}>
                  {params.InputProps.endAdornment}
                </div>
              }
              size="medium"
              fullWidth
              {...params}
            />
          </div>
        )}
      />
      {error && <LabelError id={id} text={helperText} />}
    </div>
  )
}

PreferredChannelSelector.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  prefer: PropTypes.array,
}

export default PreferredChannelSelector
